/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Health_Nav_Landing_TaglineInputs */

const en_service_health_nav_landing_tagline = /** @type {(inputs: Service_Health_Nav_Landing_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Healthcare Navigation & Wellness Support`)
};

const fr_service_health_nav_landing_tagline = /** @type {(inputs: Service_Health_Nav_Landing_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigation en santé et soutien au bien-être`)
};

/**
* | output |
* | --- |
* | "Healthcare Navigation & Wellness Support" |
*
* @param {Service_Health_Nav_Landing_TaglineInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_health_nav_landing_tagline = /** @type {((inputs?: Service_Health_Nav_Landing_TaglineInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Health_Nav_Landing_TaglineInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_health_nav_landing_tagline(inputs)
	return fr_service_health_nav_landing_tagline(inputs)
});